import React, {Component, PropTypes} from 'react';
import {Button} from 'react-bootstrap';
import moment from 'moment';

import ReactTable from 'react-table';

import {filterableBooleanCell} from 'utils/table';
import {defaultFilterMethod} from 'utils/table';

export default class UsersList extends Component {
  static propTypes = {
    users: PropTypes.array
  };

  render() {
    const {isUpdating, all:users, selectOne} = this.props;
    const columns = [
      {
        Header: '#',
        filterable: false,
        accessor: 'index',
        Cell: props => props.value+'.',
        maxWidth: 80
      },
      {
        Header: 'Email',
        accessor: 'email',
      },
      {
        Header: 'Model',
        accessor: 'model'
      },
      {
        id: 'registerAt',
        Header: 'Registered At',
        accessor: user => moment(user.registerAt).format('YYYY-MM-DD')
      },
      {
        Header: 'Confirmed Email',
        accessor: 'isConfirmed',
        ...filterableBooleanCell
      },
      {
        Header: 'Finished Applying',
        accessor: 'isFinished',
        ...filterableBooleanCell
      },
      {
        Header: 'Approved',
        accessor: 'isApproved',
        ...filterableBooleanCell
      },
      {
        id: 'actions',
        Header: 'Actions',
        sortable: false,
        filterable: false,
        accessor: user => (
          <Button onClick={selectOne(user._id)}>
            View Details
          </Button>
        )
      }
    ];

    const usersIndexed = users && users.map((el,index) => ({index:index+1, ...el})) //immutable

    return <ReactTable
      loading={isUpdating || !users }
      data={usersIndexed}
      columns={columns}
      defaultFilterMethod={defaultFilterMethod}
      filterable />;
  }
}



// WEBPACK FOOTER //
// ./src/components/users/DataGrid.jsx